import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_home_decor_fragrances: FaireCategoryEntity = {
  token: "cat_home-decor-fragrances",
  type: "category",
  name: "Home fragrances",
  level: 2,
  parentToken: "cat_home-decor",
  href: "/category/home-decor/home-fragrances",
  childCategoryTokens: [
    "cat_fragrances-all",
    "cat_fragrances-incense",
    "cat_fragrances-sprays",
    "cat_fragrances-sages",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
